angular.module('workflow')
    .controller('WorkflowAccessGroupDialogController', function ($rootScope, $uibModalInstance, data, toastr, WorkflowAccessGroup, WorkflowAccessGroupConst) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss()

        this.save = () => {
            let $promise
            if (this.item.id !== null) {
                $promise = WorkflowAccessGroup.update(this.item).$promise
            } else {
                $promise = WorkflowAccessGroup.save(this.item).$promise
            }
            return $promise
                .then(result => {
                    $rootScope.$broadcast(WorkflowAccessGroupConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
        }
    })
